import type { Prontidao } from "../types"
import { nota as formatarNota } from "./format"

export const ROTULO: Record<Prontidao["estado"], string> = {
  nao_preparado: "Não preparado",
  em_preparacao: "Em preparação",
  pronto: "Pronto para a prova",
}

/**
 * A frase de próximo passo, derivada do estado. Uma função só, para o painel e
 * a tela de resultado dizerem a mesma coisa — e para a nota mínima vir do
 * servidor, nunca do texto.
 */
export function fraseDeProntidao(p: Prontidao): string {
  const minima = formatarNota(p.nota_minima)
  const [ultima, penultima] = p.ultimas

  if (p.estado === "pronto") {
    return `Os dois últimos foram ${formatarNota(penultima)} e ${formatarNota(ultima)}. Marque a prova sabendo que vai passar.`
  }
  if (p.estado === "nao_preparado") {
    return `Faltam ${p.seguidas} simulados no formato da prova, seguidos, com ${minima} ou mais.`
  }
  if (p.faltam === 1) {
    return `Falta 1: o último foi ${formatarNota(ultima)}. Mais um com ${minima} ou mais e você está pronto.`
  }
  return `O último foi ${formatarNota(ultima)}. Faltam ${p.seguidas} seguidos com ${minima} ou mais.`
}
